import dayjs from 'dayjs'
import { trpc } from '../../../modules/trpc'

export interface DiscountMonths {
	freeMonthlyFeeMonths: number
	zeroMarginMonths: number
}

export interface Discounts {
	remaining: DiscountMonths
	total: DiscountMonths
}

export const useProductDiscounts = (
	contractId: number | null,
	contractStartDate: string | null
): Discounts => {
	const { data: product } = trpc.synerall.productInformation.useQuery(
		{
			productId: contractId ?? 0,
		},
		{
			enabled: contractId !== null,
			staleTime: 6 * 60 * 60 * 1000, // 6 hours
		}
	)

	const calculateRemainingFreeMonths = (
		totalFreeMonths: number,
		startDate: string | null
	): number => {
		if (!startDate || totalFreeMonths === 0) return totalFreeMonths

		const contractStart = dayjs(startDate)
		const now = dayjs()

		const monthsSinceStart = now.diff(contractStart, 'month')
		const adjustedMonthsSinceStart = Math.max(0, monthsSinceStart - 1)

		const remainingMonths = Math.max(0, totalFreeMonths - adjustedMonthsSinceStart)

		return remainingMonths
	}

	const totalFreeMonthlyFeeMonths = product?.NumberOfMonthsToSkipFirstMonthlyFee ?? 0
	const totalZeroMarginMonths = product?.NumberOfMonthsWithZeroMargin ?? 0

	return {
		remaining: {
			freeMonthlyFeeMonths: calculateRemainingFreeMonths(
				totalFreeMonthlyFeeMonths,
				contractStartDate
			),
			zeroMarginMonths: calculateRemainingFreeMonths(totalZeroMarginMonths, contractStartDate),
		},
		total: {
			freeMonthlyFeeMonths: totalFreeMonthlyFeeMonths,
			zeroMarginMonths: totalZeroMarginMonths,
		},
	}
}
